export default __webpack_public_path__ + "static/christian-wiediger-WkfDrhxDMC8-unsplash-fbe41b059ba3bdeb8ea94ab2f42a763c.jpg";